<header class="modal__header">
  <h2 class="modal__title" matDialogTitle>{{title | translate}}</h2>
  <button mat-icon-button
          color="primary"
          class="modal__close"
          [title]="'APP.GENERAL.CLOSE' | translate"
          mat-dialog-close>
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</header>

<section class="modal__content">
  <p *ngIf="!isInfoModalData()"> {{message | translate}} </p>
  <p *ngIf="isInfoModalData() && !hasLink()"> {{message | translate:translateParams}} </p>
  <p *ngIf="isInfoModalData() && hasLink()"> {{message | translate:translateParams}}
    <span class="modalLink" (click)="goToLink(link.value)"> {{ link.key }} </span>
  </p>

  <p class="modal__details" *ngIf="isInfoModalData() && details">
    {{ details }}
  </p>
</section>

<div class="modal__footer">
  <button type="button" class="button button--primary" mat-dialog-close>
    <span>{{ 'APP.GENERAL.OK' | translate }}</span>
  </button>
</div>
